import TechnicalAssistanceConfirmAssistanceModal from './technical-assistance-confirm-assistance-modal.vue'
export default TechnicalAssistanceConfirmAssistanceModal
